(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("iviewSelect", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["iviewSelect"] = factory(require("vue"));
	else
		root["iviewSelect"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_23__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition